import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { BrMaskerModule } from 'br-mask';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCDeviceComponent = class UiCDeviceComponent {
    constructor() {
        this.onChange = new EventEmitter();
    }
    ngOnInit() { }
};
__decorate([
    Input()
], UiCDeviceComponent.prototype, "formDevice", void 0);
__decorate([
    Input()
], UiCDeviceComponent.prototype, "errorMessages", void 0);
__decorate([
    Output()
], UiCDeviceComponent.prototype, "onChange", void 0);
UiCDeviceComponent = __decorate([
    Component({
        selector: 'ui-c-device',
        template: "<form class=\"w100 ion-text-center\" [formGroup]=\"formDevice\">\n  <div class=\"details\">\n    <ion-row>\n      <ion-col size=\"12\">\n        <div class=\"detail-item\">\n          <ion-item>\n            <span class=\"icn-holder\" slot=\"end\" *ngIf=\"!formDevice.invalid\">\n              <ion-icon name=\"checkmark-circle\"></ion-icon>\n            </span>\n            <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\" type=\"tel\"\n              formControlName=\"phone\" class=\"ion-input phone\"\n              placeholder=\"{{ 'ONBORDING.VALIDATION_PHONE.FORM.PHONE.PLACEHOLDER' | wlpTranslate }}\"\n              [brmasker]=\"{phone: true}\" maxLength=\"15\">\n            </ion-input>\n          </ion-item>\n\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.phone\">\n              <div class=\"error-message\" *ngIf=\"\n                  formDevice.get('phone').hasError(error.type) &&\n                  (formDevice.get('phone').dirty || formDevice.get('phone').touched)\n                \">\n                {{ error.message | wlpTranslate: error?.param }}\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </ion-col>\n    </ion-row>\n  </div>\n</form>",
        styles: [""]
    })
], UiCDeviceComponent);

let UiCDeviceModule = class UiCDeviceModule {
};
UiCDeviceModule = __decorate([
    NgModule({
        declarations: [UiCDeviceComponent],
        imports: [CommonModule, ReactiveFormsModule, IonicModule, BrMaskerModule, UiBsTranslateModule],
        exports: [UiCDeviceComponent],
    })
], UiCDeviceModule);

/*
 * Public API Surface of ui-c-device
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCDeviceComponent, UiCDeviceModule };
//# sourceMappingURL=wlp-ui-c-device.js.map
